import { useMemo } from 'react';
import { biLogger } from '../../../services/biLogger';
import { Orientations } from '../useVideoMaker/videoMaker.types';

interface ITrackEditTemplateClick {
  format: Orientations;
  entityId: string;
}

export const useTrackEditTemplateClick = () =>
  useMemo(
    () => ({
      trackEditTemplateClick: ({ format, entityId }: ITrackEditTemplateClick) =>
        biLogger.videoMakerEditTemplateClick({
          format,
          entity_id: entityId,
        }),
    }),
    [],
  );
